//import { Configuration } from 'msal';

//export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

// #region 1) B2C policies and user flows
/**
 * Enter here the user flows and custom policies for your B2C application, DEPLOY
 */
export const b2cPolicies = {
  authorityDomain:"mybgcanet.b2clogin.com",
  names: {
      signUpSignIn: "b2c_1a_ibgca_iam_emailid_susi",
      resetPassword: "b2c_1a_ibgca_iam_emailid_passwordreset",
      editProfile: "b2c_1a_ibgca_iam_emailid_profileedit"
  },
  authorities: {
      signUpSignIn: {
          authority: "https://mybgcanet.b2clogin.com/mybgcanet.onmicrosoft.com/b2c_1a_ibgca_iam_emailid_susi",
      },
      resetPassword: {
          authority: "https://mybgcanet.b2clogin.com/mybgcanet.onmicrosoft.com/b2c_1a_ibgca_iam_emailid_passwordreset",
      },
      editProfile: {
          authority: "https://mybgcanet.b2clogin.com/mybgcanet.onmicrosoft.com/b2c_1a_ibgca_iam_emailid_profileedit"
      }
  }

};


// #endregion


// #region 2) Web API Configuration
/**
* Enter here the coordinates of your Web API and scopes for access token request
* The current application coordinates were pre-registered in a B2C tenant.
*/
export const apiConfig: {scopes: string[]; webApi: string} = {
  scopes: ['https://mybgcanet.onmicrosoft.com/mybgcanet.API/mybgcanet.api.read'],
  webApi: 'https://iamapi.mybgca.net'
};
// #endregion



// #region 3) Authentication Configuration
/**
* Config object to be passed to Msal on creation. For a full list of msal.js configuration parameters,
* visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_configuration_.html
*/
export const msalConfig = {
  auth: {
      clientId: 'ff89ef3a-62d3-4b19-ad08-00441bd67e6f',
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      redirectUri: 'https://www.mybgca.net',
      postLogoutRedirectUri: 'https://www.mybgca.net/sign-out.html',
      navigateToLoginRequestUrl: true,
      validateAuthority: false,
    },
  cache: {
      cacheLocation: 'sessionStorage'
  },
};

export const environment = {
  production: true,
  apiHost: apiConfig.webApi
};
export const myBGCAppId = {
  clientId: '1601b0a7-63e5-45c7-9fa2-982f65541b2d',
  applicationId: 'c3ea144a-f663-4a97-8044-2e140aa5f469'
}